module.exports = __webpack_public_path__ + "img/checked.4a9553c5.svg";